<template>
  <div class="main-content">
    <div class="page-content">
      <!-- start page title -->
      <app-page-title title="Boards" :breadcrumbs="breadcrumbs" />
      <!-- end page title -->
      <template v-if="items && list">
        <board-list :items="items" @handle="handleBoard" @handle2="handleExclude" />
      </template>
      <template v-else>
        <board-form  :item="item" @handle="handleUpdate" @handle2="alterLayout" v-if="!item" />
      </template>
    </div>
    <!-- End Page-content -->
  </div>
</template>
<script>
import AppPageTitle from "@/components/AppPageTitle/AppPageTitle.vue";
import GroupList from "@/views/admin/groups/List.vue";
import BoardForm from "@/views/admin/boards/Form.vue";
import BoardList from "@/views/admin/boards/List.vue";
import { mapActions } from "vuex";
export default {
  components: {
    AppPageTitle,
    BoardForm,
    BoardList
  },
  data() {
    return {
      total: 0,
      items: null,
      item: null,
      list: true,
      breadcrumbs: [],
      breadcrumbsDefault: ["Configurações", "Boards"]
    };
  },
  mounted() {
    this.breadcrumbs = this.breadcrumbsDefault;
    this.getBoards();
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    alterLayout() {
      this.list = !this.list;
      this.breadcrumbs =
        this.list === true
          ? this.breadcrumbsDefault
          : ["Configurações", "Board"];
    },
    getBoards() {
      const options = this.$getAPIHeaders("GET", "board");
      let _this = this;
      this.axios(options)
        .then(function(response) {
          console.log(response.data.data.data);
          _this.items = response.data.data.data;
        })
        .catch(function(error) {
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    handleUpdate(newObj = null) {
      if (Object.keys(newObj).length > 0) {
        this.updateObject(newObj);
      }
      this.alterLayout();
    },
    updateObject(newObj) {
      const index = this.items.findIndex(item => item.id === newObj.id);
      if (index !== -1) {
        this.items[index] = {
          ...this.items[index],
          ...newObj
        };
      } else {
        this.items.push(newObj);
      }
    },
    handleBoard(id) {
      if (id) {
        this.item = this.items.find(el => el.id === id);
      } else {
        this.item = null;
      }
      this.alterLayout();
    },
    handleExclude(id){
      let temp = this.items.filter(el => el.id != id);
      this.items = temp;
    }
  }
}
</script>